import { HttpContext } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/core/api/api.service';
import { REFUND_ENDPOINTS } from 'src/app/core/api/endpoints/refund.endpoints';
import { BUTTON_LOADING_ID } from 'src/app/shared/global/http-context-tokens';

@Injectable({
  providedIn: 'root'
})
export class RefundService {
  private api = inject(ApiService);

  changeRefundStatus(orderID, isPaid): Observable<any> {
    return this.api
      .put<any>(REFUND_ENDPOINTS.V1.REFUND_IS_PAID(orderID), isPaid);
  }

  createManualRefund(orderId, refundData, buttonId?): Observable<any> {
    const payload = {
      reason: refundData.refundReason,
      type: refundData.refundType,
      change_order_status_to_cancel: refundData.changeOrderStatusToCancel,
      received_on_date: refundData.refundDate,
      qoyod_customer_id: refundData.qoudClinetNumber,
      credit_note_id: refundData.qoudNotificationNumber,
      payment_voucher_id: refundData.bondNumber,
      payment_method: refundData.paymentMethod,
    }
    if (refundData.value) {
      payload['value'] = refundData.value;
    }
    if (refundData.inspector_share_after_refund) {
      payload['inspector_share_after_refund'] = refundData.inspector_share_after_refund;
    }
    return this.api.post<any>(REFUND_ENDPOINTS.V1.ORDER_REFUND(orderId), payload, {
      context: new HttpContext().set(BUTTON_LOADING_ID, buttonId)
    });
  }

  getOrderCostRefund(orderID): Observable<any> {
    return this.api
      .get<any>(REFUND_ENDPOINTS.V1.ORDER_COST_REFUNDS(orderID));
  }

  createCostRefund(orderID, refundData, buttonId): Observable<any> {
    return this.api
      .post<any>(REFUND_ENDPOINTS.V1.ORDER_COST_REFUNDS(orderID), refundData, {
        context: new HttpContext().set(BUTTON_LOADING_ID, buttonId)
      });
  }

  getRefundReasons() {
    return this.api.get<any>(REFUND_ENDPOINTS.V1.REFUND_REASONS);
  }

  getRefundType(): Observable<any> {
    return this.api.get<any>(REFUND_ENDPOINTS.V1.REFUND_TYPES);
  }

  calculateRefundValue(orderID, refundData): Observable<any> {
    return this.api.post<any>(
      REFUND_ENDPOINTS.V1.CALCULATE_REFUND_VALUE(orderID),
      refundData
    );
  }
}
